import axios from 'axios'
import type { AxiosInstance } from 'axios'
import type { YYRequestConfig, YYRequestInterceptors } from './type'

// 请求时出现 loading
import { ElLoading, ElMessage } from 'element-plus'

const DEAFULT_LOADING = true
// 生成一个 axios 实例
class YYReuqest {
  instance: AxiosInstance
  interceptors?: YYRequestInterceptors
  showLoading: boolean
  loading?: any

  constructor(config: YYRequestConfig) {
    this.instance = axios.create(config) // 一个axios实例，通过这个实例完成所有请求
    this.showLoading = config.showLoading ?? DEAFULT_LOADING // 请求数据时，是否显示遮罩层加载器
    this.interceptors = config.interceptors // 拦截器

    // 使用拦截器
    // 1.从config中取出的拦截器是对应的实例的拦截器
    this.instance.interceptors.request.use(
      this.interceptors?.requestInterceptor,
      this.interceptors?.requestInterceptorCatch
    )

    this.instance.interceptors.response.use(
      this.interceptors?.responseInterceptor,
      this.interceptors?.responseInterceptorCatch
    )

    // 2.添加所有的实例都有的拦截器
    this.instance.interceptors.request.use(
      (config) => {
        if (this.showLoading) {
          this.loading = ElLoading.service({
            lock: true,
            text: '正在请求数据....',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
        }
        return config
      },
      (err) => {
        return err
      }
    )

    this.instance.interceptors.response.use(
      (res) => {
        setTimeout(() => {
          this.loading?.close()
        }, 1000)

        const data = res.data
        if (data.returnCode === '-1001') {
          ElMessage.error(data.msg || '请求失败~')
          return Promise.reject(data)
        } else {
          return data
        }
      },
      (err) => {
        this.loading?.close()
        ElMessage.error(err.message || '网络请求失败~')
        return Promise.reject(err)
      }
    )
  }

  request<T>(config: YYRequestConfig<T>): Promise<T> {
    // 无法在请求时，模拟调用自定义拦截器，因为自定义拦截器的参数类似是 AxiosRequestConfig，而真实拦截器的类型是
    return new Promise((resolve, reject) => {
      // 1.单个请求对请求config的处理
      if (config.interceptors?.requestInterceptor) {
        config = config.interceptors.requestInterceptor(config)
      }

      // 2.判断是否需要显示loading
      if (config.showLoading === false) {
        this.showLoading = config.showLoading
      }

      // request 定义的类型参数二，就是 then 后的类型
      this.instance
        .request<any, T>(config)
        .then((res) => {
          // 1.单个请求对数据的处理
          if (config.interceptors?.responseInterceptor) {
            res = config.interceptors.responseInterceptor(res)
          }

          // 2.将showLoading设置true, 这样不会影响下一个请求
          this.showLoading = DEAFULT_LOADING
          resolve(res)
        })
        .catch((err) => {
          // 将showLoading设置true, 这样不会影响下一个请求
          this.showLoading = DEAFULT_LOADING
          reject(err)
        })
    })
  }

  get<T = any>(config: YYRequestConfig<T>): Promise<T> {
    return this.request<T>({ ...config, method: 'GET' })
  }

  post<T = any>(config: YYRequestConfig<T>): Promise<T> {
    return this.request<T>({ ...config, method: 'POST' })
  }

  delete<T = any>(config: YYRequestConfig<T>): Promise<T> {
    return this.request<T>({ ...config, method: 'DELETE' })
  }

  patch<T = any>(config: YYRequestConfig<T>): Promise<T> {
    return this.request<T>({ ...config, method: 'PATCH' })
  }
}

export default YYReuqest
